import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import { NavigationHeader } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
/**
 * Browsers can't read the device's contacts, so on web this renders only the
 * header. The share link below it is how people invite friends on web.
 */
export const ContactsList = ({ headerTitle, leftContent, rightContent, }) => {
    const scrollY = useSharedValue(0);
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    return (<View style={styles.container}>
      <NavigationHeader scrollY={scrollY} leftContent={leftContent} rightContent={rightContent}/>
      <View style={paddingHorizontalStyle}>
        <ScreenInfoHeader title={headerTitle}/>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
